import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import AxiosConfig from "../../../../utilities/AxiosConfig"
import "./VehicleNotes.css"

interface VehicleNotesProps {
    notes: Array<any>
    refreshAll: Function
    userId: any
    info: any
}

type VehicleNotesTypes = {
    viewNote: boolean
    newNote: boolean
    deleteNote: boolean
    currentNote: any
    input: string
    editing: boolean
    ascending: boolean
}

class VehicleNotes extends Component<VehicleNotesProps, VehicleNotesTypes> {

    constructor(props: any) {
        super(props)
        this.state = {
            viewNote: false,
            newNote: false,
            deleteNote: false,
            currentNote: {},
            input: "",
            editing: false,
            ascending: true
        }
    }

    viewNote = (note: any) => {
        if (this.state.viewNote) {
            this.setState({ viewNote: false, newNote: false, editing: false, currentNote: {}, input: "" })
        } else {
            this.setState({ viewNote: true, newNote: false, editing: false, currentNote: note, input: note.NoteContents })
        }
    }

    newNote = () => {
        if (this.state.newNote) {
            this.setState({ viewNote: false, newNote: false, editing: false, currentNote: {}, input: "" })
        } else {
            this.setState({ viewNote: false, newNote: true, editing: false, currentNote: {}, input: "" })
        }
    }

    toggleEdit = () => {
        if (this.state.editing) {
            this.setState({ editing: false })
        } else {
            this.setState({ editing: true })
        }
    }

    toggleDelete = () => {
        if (this.state.deleteNote) {
            this.setState({ deleteNote: false })
        } else {
            this.setState({ deleteNote: true })
        }
    }

    toggleSort = () => {
        if (this.state.ascending) {
            this.setState({ ascending: false })
        } else {
            this.setState({ ascending: true })
        }
    }

    saveNote = (action: string) => {
        let requestBody = {}
        if (action === "edit") {
            requestBody =
            {
                VehicleNoteId: this.state.currentNote.VehicleNoteId,
                VehicleInformationId: this.state.currentNote.VehicleInformationId,
                NoteContents: this.state.input,
                CreatedDate: this.state.currentNote.CreatedDate,
                CreatedBy: this.state.currentNote.CreatedBy,
                ModifyDate: Date.now(),
                ModifiedBy: this.props.userId,
                DeletedDate: "",
                DeletedBy: "",
                DisabledDate: "",
                DisabledBy: ""
            }
        }

        if (action === "new") {
            requestBody =
            {
                VehicleNoteId: "",
                VehicleInformationId: this.props.info.VehicleInformationId,
                NoteContents: this.state.input,
                CreatedDate: Date.now(),
                CreatedBy: this.props.userId,
                ModifyDate: Date.now(),
                ModifiedBy: this.props.userId,
                DeletedDate: "",
                DeletedBy: "",
                DisabledDate: "",
                DisabledBy: ""
            }
        }

        if (action === "delete") {
            requestBody =
            {
                VehicleNoteId: this.state.currentNote.VehicleNoteId,
                VehicleInformationId: this.state.currentNote.VehicleInformationId,
                NoteContents: "",
                CreatedDate: "",
                CreatedBy: "",
                ModifyDate: "",
                ModifiedBy: "",
                DeletedDate: moment().format(),
                DeletedBy: this.props.userId,
                DisabledDate: "",
                DisabledBy: ""
            }
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateVehicleNote", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ viewNote: false, newNote: false, deleteNote: false, currentNote: {}, input: "", editing: false })
                this.props.refreshAll("notes")
                //console.log(res)
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    handleChange = (event: any) => {
        this.setState({ input: event.target.value })
    }

    render() {

        const newNoteTooltip = (
            <Tooltip id="vi-pin-tooltip">
                Add a new note
            </Tooltip>
        )

        let notes = this.props.notes

        if (this.state.ascending) {
            notes.sort((a, b) => (a.CreatedDate < b.CreatedDate) ? 1 : -1)
        } else {
            notes.sort((a, b) => (a.CreatedDate > b.CreatedDate) ? 1 : -1)
        }

        return (
            <div className="VehicleNotes">
                <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={newNoteTooltip}>
                    <div id="new-vehicle-note-btn" onClick={() => this.newNote()}>
                        <span className="material-icons">note_add</span>
                    </div>
                </OverlayTrigger>
                {notes.length === 0 && <div className="NoVehicleNotesWrapper">
                    <p>No Vehicle Notes</p>
                </div>}
                {notes.length > 0 && <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th id="vehicle-notes-custom-date-table-column">Date
                            <div id="vehicle-notes-sort-icon-wrapper" onClick={() => this.toggleSort()}>
                                    <p id="vehicle-notes-sort-icon-top" className="material-icons">expand_less</p>
                                    <p id="vehicle-notes-sort-icon-bottom" className="material-icons">expand_more</p>
                                </div>
                            </th>
                            <th id="vehicle-notes-name-width-hack">Employee Name</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notes.map(note =>
                            <tr key={"note-" + note.VehicleNoteId} onClick={() => this.viewNote(note)}>
                                <td id="vehicle-notes-custom-date-table-column">{moment(note.CreatedDate).format('MMMM Do YYYY')}</td>
                                <td id="vehicle-notes-name-width-hack">{note.CreatedByName}</td>
                                <td id="vehicle-note-content">{note.NoteContents}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>}
                {this.state.viewNote && <Modal id="fleet-note-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    {!this.state.deleteNote && <div id="vehicle-note-delete-btn" onClick={() => this.toggleDelete()}>
                        <span className="material-icons">delete</span>
                    </div>}
                    {!this.state.deleteNote && <Modal.Header>
                        <Modal.Title>Created By: {this.state.currentNote.CreatedByName}</Modal.Title>
                    </Modal.Header>}
                    {this.state.deleteNote && <Modal.Header>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>}
                    {!this.state.editing && !this.state.deleteNote && <Modal.Body>
                        {this.state.currentNote.NoteContents}
                    </Modal.Body>}
                    {this.state.editing && !this.state.deleteNote && <Modal.Body>
                        <FormControl
                            as="textarea"
                            rows={4}
                            placeholder={this.state.currentNote.NoteContents}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.input}
                        />
                    </Modal.Body>}
                    <Modal.Footer>
                        {!this.state.deleteNote && <div className="VehicleNotesModalFooter">
                            <div id="vehicle-notes-modal-footer-left">
                                {!this.state.editing && <Button id="vehicle-notes-edit-btn" variant="secondary" onClick={() => this.toggleEdit()}>Edit</Button>}
                                {this.state.editing && <Button id="vehicle-notes-save-btn" variant="primary" onClick={() => this.saveNote("edit")}>Save</Button>}
                                {this.state.editing && <Button id="vehicle-notes-cancel-btn" variant="secondary" onClick={() => this.toggleEdit()}>Cancel</Button>}
                            </div>
                            <div id="vehicle-notes-modal-footer-right">
                                {!this.state.editing && <Button id="vehicle-notes-back-btn" variant="secondary" onClick={() => this.viewNote({})}>Close</Button>}
                            </div>
                        </div>}
                        {this.state.deleteNote && <div id="vehice-notes-confirm-delete">
                            <Button id="vehicle-notes-delete-btn" variant="danger" onClick={() => this.saveNote("delete")}>Delete</Button>
                            <Button id="vehicle-notes-dont-delete-btn" variant="secondary" onClick={() => this.toggleDelete()}>Cancel</Button>
                        </div>}
                    </Modal.Footer>
                </Modal>}
                {this.state.newNote && <Modal id="fleet-note-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        <Modal.Title>New Note</Modal.Title>
                    </Modal.Header>
                    <FormControl
                        as="textarea"
                        rows={4}
                        placeholder={"Note Text..."}
                        aria-describedby="basic-addon1"
                        onChange={this.handleChange}
                        value={this.state.input}
                    />
                    <Modal.Footer>
                        <div className="VehicleNotesModalFooter">
                            <div id="vehicle-notes-modal-footer-left">
                                {this.state.input.length > 0 && <Button id="vehicle-notes-save-btn" variant="primary" onClick={() => this.saveNote("new")}>Save</Button>}
                            </div>
                            <div id="vehicle-notes-modal-footer-right">
                                <Button id="vehicle-notes-back-btn" variant="secondary" onClick={() => this.newNote()}>Cancel</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default VehicleNotes